import { Link } from 'react-router-dom'
import { BarChart3 } from 'lucide-react'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function RequestHeader() {
  return (
    <Card className="relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-indigo-400/10 to-transparent dark:from-indigo-400/5 rounded-full -translate-y-8 translate-x-8" />
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-2xl font-bold tracking-tight flex items-center gap-2">
              <BarChart3 className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
              Request Analytics
            </CardTitle>
            <p className="text-muted-foreground">Request Instagram profile analysis. Once the account is analyzed, you can view the results in <Link to="/saved-accounts" className="text-blue-500 hover:underline">Saved Accounts</Link>.</p>
          </div>
          <Badge variant="secondary" className="text-xs">
            Analysis
          </Badge>
        </div>
      </CardHeader>
    </Card>
  )
} 